import { render } from "./LawyersList.vue?vue&type=template&id=1d4f1fc1&scoped=true"
import script from "./LawyersList.vue?vue&type=script&lang=js"
export * from "./LawyersList.vue?vue&type=script&lang=js"

import "./LawyersList.vue?vue&type=style&index=0&id=1d4f1fc1&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4f1fc1"]])

export default __exports__